import { lazy } from 'react';




//sets the pages display settings

const SubClientActivationConfig = {
  settings: {
    layout: {
        style : 'layout1',
        config: {
          
            navbar : {
                display : false,
                
            },
            toolbar: {
                display : false,
            },
            footer : {
                display : false,
                
            },
            mode   : 'fullwidth'
        }
    },
    
},
  routes: [
    {
      path: '/client-activation/:code',
      component: lazy(() => import('./SubClientActivation')),
    },
  ],
};

export default SubClientActivationConfig
